import { Col, Form, Input, Row, Typography } from "antd";
import { memo } from "react";

import { Rules } from "../../../../../../../constants";
import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { StringHelper } from "../../../../../../../helper";
import { FormText } from "../../form-text";

interface Props {
  isSearching?: boolean;
  onSearchUser?: (value: string) => Promise<void>;
  data?: any;
}

const { Search } = Input;

export const GeneralForm = memo(
  ({ data, isSearching, onSearchUser }: Props) => {
    const isCreateForm = data === undefined;

    return (
      <Row gutter={[24, 0]}>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item
              label="Mã nhân viên"
              name="eEmployeeId"
              rules={[Rules.required()]}
            >
              <Search loading={isSearching} onSearch={onSearchUser} />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Mã nhân viên"
              textRight={data?.eEmployeeId}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item
              label="Họ tên"
              name="eRequestName"
              rules={[Rules.required()]}
            >
              <Input disabled />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Họ tên"
              textRight={data?.eRequestName}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item
              label={
                <Typography.Text
                  ellipsis={{ tooltip: "Số ngày phép còn lại trong năm" }}
                >
                  Số ngày phép còn lại trong năm
                </Typography.Text>
              }
              name="eRemainingAnnualLeave"
            >
              <Input disabled />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Số ngày phép còn lại trong năm"
              textRight={data?.eRemainingAnnualLeave}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item label="Chức danh" name="ePosition">
              <FormText />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Chức danh"
              textRight={StringHelper.verticalBarSplit(data?.ePosition)[1]}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item label="Cơ quan/Đơn vị" name="eDepartment">
              <FormText />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Cơ quan/Đơn vị"
              textRight={StringHelper.verticalBarSplit(data?.eDepartment)[1]}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item label="Đơn vị" name="eUnit">
              <FormText />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Đơn vị"
              textRight={StringHelper.verticalBarSplit(data?.eUnit)[1]}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          {isCreateForm ? (
            <Form.Item label="Đội/Nhóm" name="eTeam">
              <FormText />
            </Form.Item>
          ) : (
            <BoxSectionItem
              ellipsis
              textLeft="Đội/Nhóm"
              textRight={StringHelper.verticalBarSplit(data?.eTeam)[1]}
            />
          )}
        </Col>
      </Row>
    );
  }
);
